import script from "./VodOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./VodOverview.vue?vue&type=script&setup=true&lang=js"

import "./VodOverview.vue?vue&type=style&index=0&id=53198fdf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53198fdf"]])

export default __exports__